var map = {
	"./base/Box.vue": "8f7e",
	"./base/Button.vue": "d084",
	"./base/Col.vue": "77a9",
	"./base/Container.vue": "45b1",
	"./base/Image.vue": "eb4a",
	"./base/Images.vue": "dc14",
	"./base/Link.vue": "9689",
	"./base/Links.vue": "4309",
	"./base/List.vue": "87fc",
	"./base/Row.vue": "380e",
	"./base/Sections.vue": "caaa",
	"./base/Segment.vue": "4879",
	"./base/Slide.vue": "40fd",
	"./base/Spinner.vue": "f34e",
	"./base/Svg.vue": "5b17",
	"./base/Text.vue": "b9e7",
	"./base/Video.vue": "ead9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2763";